import { useState, useEffect } from "react";
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import {
  specialitiesWaitListState,
  specialityWaitListState,
  professionalWaitListState,
  showWaitListState,
  specialitiesFetchState,
  specialitiesByProfessionalFetchState,
} from "../state/atoms";
import { filterSearchSelectedState } from "src/SearchHours/state/atoms";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import { dayDefaultAvailableState } from "src/SearchHours/components/calendars/state/atoms";

export const useSpecialities = () => {
  const { catchErrorApi } = useCatchErrorApi();

  const [specialities, setSpecialities] = useRecoilState(
    specialitiesWaitListState
  );
  const specialitySelected = useRecoilValue(specialityWaitListState);
  const professionalSelected = useRecoilValue(professionalWaitListState);
  const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  const setShowWaitList = useSetRecoilState(showWaitListState);
  const dayDefaultAvailable = useRecoilValue(dayDefaultAvailableState);

  const [loading, setLoading] = useState(false);

  const loadSpecialities = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        setLoading(true);
        try {
          const professionalFilter = filterSearchSelected.professionalSelected;
          const specialityFilter = filterSearchSelected.specialitySelected;

          if (specialitySelected.code === null && professionalSelected.code) {
            const specialitiesByProfessionalFetch = snapshot.getPromise(
              specialitiesByProfessionalFetchState(professionalSelected.code)
            );

            const response = await specialitiesByProfessionalFetch;

            setSpecialities(response.data);
          } else {
            const specialitiesFetch = snapshot.getPromise(
              specialitiesFetchState(dayDefaultAvailable)
            );

            const specialitiesByProfessionalFetch = snapshot.getPromise(
              specialitiesByProfessionalFetchState(professionalFilter.code)
            );

            const responses = await Promise.all([
              specialitiesFetch,
              specialitiesByProfessionalFetch,
            ]);


            const filterValues = responses[1].data;

            const response = responses[0];

            const filterSpecialities = response.filter((speciality) => {
              const matchesProfessional = filterValues.some(
                (filterSpeciality) =>
                  filterSpeciality.esCodigo === speciality.espCodigo
              );

              const matchesSelectedSpeciality =
                specialityFilter &&
                specialityFilter.code === speciality.espCodigo;

              return matchesProfessional || matchesSelectedSpeciality;
            });

            if (filterSpecialities.length > 0) {
              setShowWaitList(true);
            }

            setSpecialities(response);
          }
        } catch (error) {
          catchErrorApi(error);
        } finally {
          setLoading(false);
        }
      },
    [filterSearchSelected, setSpecialities]
  );

  useEffect(() => {
    loadSpecialities();
  }, [dayDefaultAvailable, loadSpecialities]);

  return { specialities, loading, loadSpecialities };
};
